/**
 * Helper to generate the projection angles used by the local geometry
 * computations in src/utils.
 *
 * @param {number} startAngle - Start angle in degrees
 * @param {number} endAngle - End angle in degrees
 * @param {number} numProjections - Number of projections
 * @returns {number[]} Array of angles in radians
 */
export function generateAnglesForVisualization(startAngle, endAngle, numProjections) {
  const angles = [];
  const startRad = (startAngle * Math.PI) / 180;
  const endRad = (endAngle * Math.PI) / 180;

  if (numProjections === 1) {
    return [startRad];
  }

  const step = (endRad - startRad) / (numProjections - 1);

  for (let i = 0; i < numProjections; i++) {
    angles.push(startRad + i * step);
  }

  return angles;
}

export default generateAnglesForVisualization;
